import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Say } from "../../../languages";

type Props = {
  visible: boolean;
  children: React.ReactNode;
};

const SelfieAccepted = ({ visible, children }: Props) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="photo-moderation__selfie-accepted">
      {children}
      <span className="photo-moderation__selfie-accepted-icon">
        <FontAwesomeIcon icon={faCheckCircle} />
      </span>
      <p className="photo-moderation__selfie-accepted-text">
        <Say phrase="photo_step.photo_received" />
      </p>
    </div>
  );
};

export default SelfieAccepted;
